module.exports = __webpack_public_path__ + "static/search-1fef517b79951ba06987183ef7703e4b.png";